import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as cn from 'classnames';
import dlv from 'dlv';
import * as React from 'react';
import { themr } from 'react-css-themr';
import { Sticky, StickyContainer } from 'react-sticky';
import Drawer from '../Drawer';
import EntityContent from '../EntityContent';
import Toc from '../Toc';
function DumpEntityContentWithStickyToc({ entity, offset, duration, shift, ease, toogleButton = React.createElement(FontAwesomeIcon, { icon: "list" }), renderContent = (_entity) => React.createElement(EntityContent, { entity: entity }), theme = {}, }) {
    const [isShowDrawer, onShowDrawer] = React.useState(false);
    return (React.createElement(StickyContainer, { className: theme.root },
        React.createElement(Sticky, null, ({ isSticky }) => !isSticky ? (React.createElement("div", null)) : (React.createElement("a", { onClick: () => onShowDrawer(true), className: theme.toggleButtonWrapper },
            React.createElement("span", { className: theme.toggleButton }, toogleButton)))),
        React.createElement("div", { className: theme.sidebar },
            React.createElement(Sticky, null, ({ style, isSticky }) => (React.createElement("div", { style: style },
                React.createElement("div", { className: cn(theme.sidebarContent, {
                        'vh-100': isSticky,
                    }) },
                    React.createElement(Toc, { offset: offset, duration: duration, shift: shift, ease: ease, source: dlv(entity, 'content.md', ''), theme: theme.toc })))))),
        React.createElement("div", { className: theme.main }, renderContent(entity)),
        React.createElement(Drawer, { theme: theme.drawer, isOpen: isShowDrawer, onClose: () => onShowDrawer(false) },
            React.createElement("div", null,
                React.createElement(Toc, { source: dlv(entity, 'content.md', ''), onClick: () => onShowDrawer(false), theme: theme.toc })))));
}
export const defaultEntityContentWithStickyTocTheme = {
    root: 'flex-l',
    main: 'w-100 w-70-l',
    sidebar: 'dn db-l w-30-l',
    sidebarContent: 'bg-white br b--light-gray',
    toggleButton: 'f2 pointer fixed bottom-2 right-2 bg-white br-100 w3 h3 flex items-center justify-center z-5 card',
};
const EntityContentWithStickyToc = themr('EntityContentWithStickyToc', {}, {
    composeTheme: 'softly',
})(DumpEntityContentWithStickyToc);
export default EntityContentWithStickyToc;
//# sourceMappingURL=index.js.map